module.exports = __webpack_public_path__ + "img/colorMap_4096_compressed.90666e63.jpg";